<style scoped>
    .users{
        padding: .24rem;
    }
    .userItem{
        padding: .24rem;
        box-shadow:0 .03rem .09rem 0 rgba(120,120,120,0.19);
        border-radius: .1rem;
        background: #fff;
        margin-bottom: .2rem;
    }
    .userTop{
        display: flex;
        justify-content: space-between;
        color: #000000;
        font-size: .28rem;
        padding-bottom: .22rem;
        border-bottom: .01rem solid #DCDCDC;
    }

    .mainBox{
        display: flex;
        padding-top: .26rem;
    }

    .userImg{
        width: .9rem;
        height: .9rem;
        background: #000;
        border-radius: 50%;
        margin-right: .22rem;
    }
    .nameBox{
        color: #161616;
        font-size: .3rem;
        margin-bottom: .24rem;
    }
    .nameBox span{
        color: #212121;
        font-size: .24rem;
        margin-left: .28rem;
    }
    .info{
        font-size: .26rem;
        color: #2C2C2C;
        margin-bottom: .16rem;
    }
    .info:last-child{
        margin-bottom: 0;
    }
</style>
<template>
    <div style="padding-top: .98rem">
        <topbar text="我的用户"></topbar>
        <div class="users">
            <div class="userItem">
                <div class="userTop">
                    咨询状态：
                    <span>已完成</span>
                </div>
                <div class="mainBox">
                    <div class="userImg"></div>
                    <div class="mainRight">
                        <div class="nameBox">
                            林更新
                            <span>男 19岁</span>
                        </div>
                        <div class="info">问题类型：学习困扰、个性成长</div>
                        <div class="info">咨询方式：视频</div>
                        <div class="info">咨询时间：2020/06/09 09:00-10:00</div>
                        <div class="info">咨询次数：1次</div>
                        <div class="info">处理结果：继续咨询</div>
                    </div>
                </div>
            </div>
            <div class="userItem">
                <div class="userTop">
                    咨询状态：
                    <span>已完成</span>
                </div>
                <div class="mainBox">
                    <div class="userImg"></div>
                    <div class="mainRight">
                        <div class="nameBox">
                            林更新
                            <span>男 19岁</span>
                        </div>
                        <div class="info">问题类型：学习困扰、个性成长</div>
                        <div class="info">咨询方式：视频</div>
                        <div class="info">咨询时间：2020/06/09 09:00-10:00</div>
                        <div class="info">咨询次数：1次</div>
                        <div class="info">处理结果：继续咨询</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,

            }
        },
        components: {
            noMoreData,
            topbar,
        },
        filters: {

            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
        },
        computed: {},
        methods: {

        },
        destroyed(){

        },
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/myUsers.vue